export default class Container {
  constructor (values) {
    this.http = null

    /** @type Cookies */
    this.cookie = null

    values && Object.assign(this, values)
  }
}